import React, { ChangeEvent, useEffect, useState } from "react";
import AuthLayout from "../../Components/Layouts/AuthLayout";
import axios from "axios";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { TeamData } from "../../types";
import {
  getAllUsers,
  inviteUser,
  reInviteUser,
  updateRole,
} from "../../features/teamSlice";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { toast } from "react-toastify";
import { BarLoader } from "react-spinners";
import moment from "moment";

const Teams = () => {
  const dispatch = useAppDispatch();
  const [executed, setExecuted] = useState(false);

  const { teams } = useAppSelector((state) => state.team);
  const [formData, setFormData] = useState<TeamData>({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    role: "",
  });

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleTeamUpdate = (status1: number, id: number) => {
    let data = {
      id: id,
      status: status1,
    };
    dispatch(updateRole(data))
      .unwrap()
      .then((response: any) => {
        dispatch(getAllUsers());
        toast.success(response.message);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  //handle submission
  const handleInviteTeam = (p0: React.FormEvent<HTMLFormElement>) => {
    setLoading(true);
    let data = {
      email: formData.email,
      first_name: formData.first_name,
      last_name: formData.last_name,
      phone: formData.phone,
      role: formData.role,
    };
    dispatch(inviteUser(data))
      .unwrap()
      .then((response: string) => {
        setShow(false);
        setLoading(false);
        dispatch(getAllUsers());
        toast.success("A notification has been sent to User");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error);
      });
  };

  const handleReInvite = (id: number) => {
    // Update the function signature  to match the inviteUser function
    let data = {
      id: id,
    };
    dispatch(reInviteUser(data))
      .unwrap()
      .then((response: string) => {
        setShow(false);
        setLoading(false);
        dispatch(getAllUsers());
        toast.success("A notification has been sent to User");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error);
      });
  };

  useEffect(() => {
    dispatch(getAllUsers());
  }, [executed]);

  console.log(teams);

  return (
    <AuthLayout>
      <h2>Users</h2>

      <div className="team-table mt-3">
        <Button
          className="float-start mb-3 btn btn-secondary rounded-0 text-white"
          onClick={handleShow}
        >
          Invite User
        </Button>
        <table className="table">
          <thead className="bg-primary text-white">
            <th>Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Role</th>
            <th>Date</th>
            <th>Status</th>
            <th>Actions</th>
          </thead>
          <tbody>
            {teams &&
              teams.data.map((item) => (
                <tr key={item.id}>
                  <td className="p-3">
                    {item.first_name} {item.last_name}
                  </td>
                  <td className="p-3">{item.email}</td>
                  <td className="p-3">{item.phone}</td>
                  <td className="p-3">
                    {item.roles.map((role, index) => (
                      <span key={index}>
                        {" "}
                        {role.name.charAt(0).toUpperCase() +
                          role.name.slice(1).toLowerCase()}{" "}
                      </span>
                    ))}
                  </td>

                  <td className="p-3">
                    {moment(item.created_at).format("MM/DD/YYYY")}
                  </td>
                  <td className="p-3">
                    <div
                      className={
                        item.active == 1
                          ? "bg-green p-2 text-white rounded-0 text-center"
                          : "bg-danger p-2 text-white rounded-0 text-center"
                      }
                    >
                      {item.active == 1 ? "Active" : "Terminated"}
                    </div>
                  </td>

                  <td className="p-3">
                    {" "}
                    <a
                      className="dropdown-toggle"
                      href="#"
                      id="dropdownMenuLink"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="bi bi-three-dots"></i>
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuLink"
                    >
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => handleTeamUpdate(1, item.id)}
                        >
                          Re-assign Role
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => handleReInvite(item.id)}
                        >
                          Re-Invite
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => handleTeamUpdate(0, item.id)}
                        >
                          Terminate
                        </a>
                      </li>
                    </ul>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Invite User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={12} md={6} className="mb-3">
                <label className="form-label">First Name</label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control border-dark rounded-0"
                    name="first_name"
                    placeholder="user first name"
                    onChange={handleChange}
                    value={formData.first_name}
                  />
                </div>
              </Col>

              <Col sm={12} md={6} className="mb-3">
                <label className="form-label">Last Name</label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control border-dark rounded-0"
                    name="last_name"
                    placeholder="user last name"
                    onChange={handleChange}
                    value={formData.last_name}
                  />
                </div>
              </Col>
              <Col sm={12} md={6} className="mb-3">
                <label className="form-label">Email Address</label>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control border-dark rounded-0"
                    name="email"
                    placeholder="user email"
                    onChange={handleChange}
                    value={formData.email}
                  />
                </div>
              </Col>

              <Col sm={12} md={6} className="mb-3">
                <label className="form-label">Phone</label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control border-dark rounded-0"
                    name="phone"
                    placeholder="Phone"
                    onChange={handleChange}
                    value={formData.phone}
                  />
                </div>
              </Col>

              <Col sm={12} md={6} className="mb-3">
                <label className="form-label">Role</label>
                <div className="form-group">
                  <select
                    className="form-select form-control rounded-0 border-dark"
                    name="role"
                    onChange={handleChange}
                    value={formData.role} // Bind the select element to formData.role
                  >
                    <option value="">Select Role</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
              </Col>
            </Row>

            <div className="flex d-flex justify-content-between mt-5">
              <Button
                variant="danger text-white"
                className="float-start rounded-0"
                onClick={handleClose}
              >
                Cancel
              </Button>
              {loading && loading ? (
                <BarLoader
                  color="#073367"
                  loading={loading}
                  width={150}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              ) : (
                <Button
                  variant="secondary text-white"
                  className="rounded-0"
                  onClick={(e) =>
                    handleInviteTeam(
                      e as unknown as React.FormEvent<HTMLFormElement>
                    )
                  }
                >
                  Invite
                </Button>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </AuthLayout>
  );
};

export default Teams;
